import $ from 'jquery';

$('.js-cases').each((index, cases) => {
  const $container = $(cases);
  const $filterYears = $container.find('.js-cases-years');
  const $filterCourt = $container.find('.js-cases-court');
  const $filterNoteworthy = $container.find('.js-cases-noteworthy');
  const $cases = $container.find('.js-case');

  function filterByYears(index, element) {
    const $element = $(element);
    const yearsMin = Number($filterYears.attr('data-value-min'));
    const yearsMax = Number($filterYears.attr('data-value-max'));
    const year = Number($element.attr('data-year'));
    return year >= yearsMin && year <= yearsMax;
  }

  function filterByCourt(index, element) {
    const $element = $(element);
    const court = $element.attr('data-court');
    const courtValue = $filterCourt.val();
    if (courtValue === '') {
      return true;
    }
    return court === courtValue;
  }

  function filterByNoteworthy(index, element) {
    const $element = $(element);
    const noteworthy = $element.attr('data-noteworthy');
    const noteworthyValue = $filterNoteworthy.prop('checked');
    if (noteworthyValue === false) {
      return true;
    }
    return noteworthy === String(noteworthyValue);
  }

  function handleChange() {
    $cases
      .hide()
      .filter(filterByYears)
      .filter(filterByCourt)
      .filter(filterByNoteworthy)
      .show();
  }

  $filterYears.on('change', handleChange);
  $filterCourt.on('change', handleChange);
  $filterNoteworthy.on('change', handleChange);
});
